import React from 'react';
import { RegularButtonSize } from 'fronton-react';
import { RegularButton as Button } from 'fronton-react/button/regular-button/regular-button';
import { useTranslation } from 'react-i18next';

export const SurfaceFooter = (props: { size: RegularButtonSize; wide?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Button
      size={props.size}
      variant="primary"
      label={t('calculator.surface.footerButton')}
      type="submit"
      form="surface-form"
      {...(props.wide ? { wide: props.wide } : {})}>
      {t('calculator.surface.footerButton')}
    </Button>
  );
};
